import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate, Link } from "react-router-dom";
import TablePagination from "./TablePagination";

const EnquiryListLayer = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [totalRecords, setTotalRecords] = useState(5);
    const [enquiries, setEnquiries] = useState([
        {
            date: "11-11-2022",
            name: "Md. Rois Uddin Miah",
            mobile: "+8801711541788",
            email: "mdrois.uddin@gmail.com",
            city: "Dhaka",
            address: "284, 1/B, Zafrabad, Shankar, Mohammadpur, Dhaka",
            message: "I am a veterinarian and poultry consultant. I want to visit this 'India Poultry Show- 2022, venue- Coimbatore, Tamil Nadu, India."
        },
        {
            date: "11-11-2022",
            name: "Md. Rois Uddin Miah",
            mobile: "+8801711541788",
            email: "mdrois.uddin@gmail.com",
            city: "Dhaka",
            address: "284, 1/B, Zafrabad, Shankar, Mohammadpur, Dhaka, Bangladesh.",
            message: "I am a poultry veterinarian and poultry consultant. I want to visit this India poultry show 2022, venue- Coimbatore, Andhra, India."
        },
        {
            date: "11-08-2022",
            name: "K P ARAVINDAN",
            mobile: "09894250959",
            email: "kpausa@rediffmail.com",
            city: "Coimbatore",
            address: "35. K R. Puram Road. Avarampalayam. Ganapathy.",
            message: "We are Komban Soda from Coimbatore. Kindly register my mobile number for the stall bookings on your events, kindly update the events details."
        },
        {
            date: "15-07-2022",
            name: "Donny Klug",
            mobile: "(17) 8999-4138",
            email: "ntoukirhasan7860@jaypetfood.com",
            city: "Sao Jose Do Rio Preto",
            address: "Add your site to 1000 business directories with one click here-> https://1mdr.short.gy/add-your-website",
            message: "Good job on the new site! Now go ahead and submit it to our free directory here https://1mdr.short.gy/add-your-website"
        },
        {
            date: "14-07-2022",
            name: "Ariana Smith",
            mobile: "516-293-5529",
            email: "frith.ruthie@gmail.com",
            city: "Farmingdale",
            address: "Hey there! Love what you do with your website but I noticed that you don't have engaging videos promoting your business Nowadays, videos are pretty necessary for businesses to succeed so I wanted to share with you this free",
            message: "Hey there! Love what you do with your website but I noticed that you don't have engaging videos promoting your business Nowadays, videos are pretty necessary for businesses to succeed so I wanted to share with you this free"
        }
    ]);

    const filteredEnquiries = enquiries.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.mobile.includes(searchTerm)
    );

    return (
        <div className="card h-100 p-0 radius-12">
            <div
                className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between flex-wrap gap-3"
                style={{ background: "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)" }}
            >
                <div className="d-flex align-items-center gap-3">
                    <h6 className="text-white pb-2 mb-0">ENQUIRY LIST</h6>
                </div>
                <div className="d-flex align-items-center gap-3">
                    <div className="navbar-search d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ color: "black", backgroundColor: "white" }}
                        />
                    </div>
                    {/* <button 
                        onClick={() => navigate(-1)} 
                        className="btn btn-sm d-flex align-items-center gap-2 text-white" 
                        style={{ backgroundColor: "rgba(255,255,255,0.2)", border: "1px solid white" }}
                    >
                        <Icon icon="solar:alt-arrow-left-bold" />
                        Back
                    </button> */}
                </div>
            </div>
            <div className="card-body p-24">
                <div className="table-responsive scroll-sm overflow-x-auto shadow-sm border radius-8">
                    <table className="table bordered-table sm-table mb-0" style={{ minWidth: '1500px' }}>
                        <thead>
                            <tr style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}>
                                <th scope="col" style={{ color: "white", width: '70px' }} className="px-16">Sl.No</th>
                                <th scope="col" style={{ color: "white", width: '130px' }}>Date</th>
                                <th scope="col" style={{ color: "white", width: '200px' }}>Name</th>
                                <th scope="col" style={{ color: "white", width: '150px' }}>Mobile Number</th>
                                <th scope="col" style={{ color: "white", width: '250px' }}>Email</th>
                                <th scope="col" style={{ color: "white", width: '150px' }}>City</th>
                                <th scope="col" style={{ color: "white", width: '250px' }}>Address</th>
                                <th scope="col" style={{ color: "white", width: '300px' }}>Message</th>
                                <th scope="col" style={{ color: "white", textAlign: "center", width: '150px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredEnquiries.length > 0 ? (
                                filteredEnquiries.map((item, index) => (
                                    <tr key={index}>
                                        <td className="px-16">{index + 1}</td>
                                        <td>{item.date}</td>
                                        <td className="fw-medium">{item.name}</td>
                                        <td>{item.mobile}</td>
                                        <td>{item.email}</td>
                                        <td>{item.city}</td>
                                        <td style={{ minWidth: "250px" }}>{item.address}</td>
                                        <td style={{ minWidth: "300px" }}>{item.message}</td>
                                        <td className="text-center">
                                            <Link
                                                to="/clients/add"
                                                className="text-primary-600 fw-bold d-flex align-items-center justify-content-center gap-1"
                                            >
                                                <svg 
                                                    width="16" 
                                                    height="16" 
                                                    viewBox="0 0 24 24" 
                                                    fill="none" 
                                                    stroke="currentColor" 
                                                    strokeWidth="3" 
                                                    strokeLinecap="round" 
                                                    strokeLinejoin="round"
                                                >
                                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                                </svg>
                                                Add Client
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-24 text-secondary-light">
                                        No enquiries found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <TablePagination
                    currentPage={currentPage}
                    totalPages={Math.ceil(totalRecords / rowsPerPage)}
                    onPageChange={(page) => setCurrentPage(page)}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(e) => {
                        setRowsPerPage(Number(e.target.value));
                        setCurrentPage(0);
                    }}
                    totalRecords={totalRecords}
                />
            </div>
        </div>
    );
};

export default EnquiryListLayer;
